<ng-content></ng-content>
<div #clickPanel class="click-panel" [class.is-disabled]="disableClose"></div>
